[
  {
    "id": 1,
    "title": "general.title",
    "caption": "general.caption"
  },
  {
    "id": 2,
    "title": "data_collection.title",
    "caption": "data_collection.caption",
    "list": ["data_collection.list.item_0", "data_collection.list.item_1", "data_collection.list.item_2"]
  },
  {
    "id": 3,
    "title": "personal_data.title",
    "caption": "personal_data.caption",
    "list": ["personal_data.list.item_0", "personal_data.list.item_1", "personal_data.list.item_2"]
  },
  {
    "id": 4,
    "title": "data_sharing.title",
    "caption": "data_sharing.caption"
  },
  {
    "id": 5,
    "title": "data_retention.title",
    "caption": "data_retention.caption"
  },
  {
    "id": 6,
    "title": "your_rights.title",
    "caption": "your_rights.caption",
    "list": ["your_rights.list.item_0", "your_rights.list.item_1"]
  },
  {
    "id": 7,
    "title": "contact_us.title",
    "caption": "contact_us.caption",
    "email": {
      "lang_key": "contact_us.email",
      "data_key": "email"
    },
    "phone": {
      "lang_key": "contact_us.phone",
      "data_key": "phone"
    }
  }
]
